import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import styled from '@emotion/styled'

import { PendingMatchStatus } from 'src/graphql/types'
import { Button, ButtonVariant } from 'src/system/ui/button/Button'
import { discordColors } from 'src/system/ui/game-colors/brand'
import { useStalled } from 'src/screens/matches/collection/match/status/use-progress'

const DISCORD_URL = 'https://pureskill.gg/discord'

export function ProcessingModal(props: {
  status: PendingMatchStatus
  createdAt: string
  isVisible: boolean
  onClose: () => void
}) {
  const { t } = useTranslation()
  const stalled = useStalled(props.createdAt)

  const key =
    props.status === PendingMatchStatus.Created ? 'downloading' : 'processing'
  const prefix = `matches:processing_modal.${key}`

  function handleButton() {
    if (stalled) {
      window.open(DISCORD_URL, '_blank', 'noopener,noreferrer')
    }
    props.onClose()
  }

  return (
    <Dialog open={props.isVisible} onClose={props.onClose}>
      <DialogContent>
        <DialogTitle>{t(`${prefix}.title`)}</DialogTitle>
        <DialogContentText>{t(`${prefix}.body`)}</DialogContentText>
        {stalled && (
          <StalledText>{t('matches:processing_modal.stalled')}</StalledText>
        )}
      </DialogContent>
      <DialogActions>
        <StyledButton
          onClick={handleButton}
          variant={ButtonVariant.primary}
          color={stalled ? discordColors.blurple : undefined}
          darkenOnHover={stalled}
        >
          {stalled
            ? t('matches:processing_modal.stalled_button')
            : t('matches:processing_modal.button')}
        </StyledButton>
      </DialogActions>
    </Dialog>
  )
}

const StyledButton = styled(Button)`
  text-transform: uppercase;
`

const StalledText = styled(DialogContentText)`
  margin-top: ${(props) => props.theme.d.spacing[3]};
  color: ${(props) => props.theme.d.colors.error};
`
